var React = require('react');

function ArrowTop (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.0108 16.62C21.5008 16.13 21.5008 15.34 21.0108 14.85L12.7008 6.54C12.3108 6.15 11.6808 6.15 11.2908 6.54L2.98078 14.85C2.49078 15.34 2.49078 16.13 2.98078 16.62C3.47078 17.11 4.26078 17.11 4.75078 16.62L12.0008 9.38L19.2508 16.63C19.7308 17.11 20.5308 17.11 21.0108 16.62Z","fill":"#1E40CA"}));
}

ArrowTop.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ArrowTop;

ArrowTop.default = ArrowTop;
